import { Building2, Phone, Mail, MapPin } from "lucide-react";

// Sticky banner shown when a valid affiliate/segnalatore code is present.
export const PartnerBanner = ({ partner }) => {
  if (!partner) return null;
  const isSegnalatore = (partner.tipo_partner || "").toLowerCase().includes("segnalatore");
  const label = isSegnalatore ? "Segnalato da" : "Partner ufficiale";

  return (
    <div
      data-testid="partner-banner"
      className="fixed inset-x-0 top-[58px] z-40 border-b border-white/10 bg-green-700 text-white"
    >
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-6 gap-y-1 px-4 py-2 text-center text-xs sm:text-sm lg:px-8">
        <span className="inline-flex items-center gap-2 font-bold">
          <Building2 className="h-4 w-4" />
          {label}: {partner.company_name}
        </span>
        {partner.contact_phone ? (
          <a href={`tel:${partner.contact_phone}`} className="inline-flex items-center gap-1.5 hover:underline">
            <Phone className="h-3.5 w-3.5" /> {partner.contact_phone}
          </a>
        ) : null}
        {partner.contact_email ? (
          <a href={`mailto:${partner.contact_email}`} className="inline-flex items-center gap-1.5 hover:underline">
            <Mail className="h-3.5 w-3.5" /> {partner.contact_email}
          </a>
        ) : null}
        {partner.city ? (
          <span className="inline-flex items-center gap-1.5">
            <MapPin className="h-3.5 w-3.5" /> {partner.city}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default PartnerBanner;
